<template>
	<div id="plan_post_public">
        <HrrBreadcrumb PMname="岗位计划管理" CMname="岗位发布管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="计划：" prop="planId">
                        <el-select v-model="searchform.planId" placeholder="请选择" >
                            <el-option
                                v-for="item in planIdData"
                                :key="item.planId"
                                :label="item.planName"
                                :value="item.planId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-input v-model="keyword" placeholder="关键字" >
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                              <el-option label="岗位名称" value="postTitle"></el-option>
                              <el-option label="专业" value="major"></el-option>
                              <el-option label="岗位简介" value="postInfo"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="岗位类型：">
                        <el-select v-model="searchform.postType" placeholder="请选择" >
                            <el-option label="全部" key="" value=""></el-option>
                            <el-option
                            v-for="item in postTypeData"
                            :key="item.typeValue"
                            :label="item.typeName"
                            :value="item.typeValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所：" v-if="isHadFun('WhereSuo')" >
                        <el-select v-model="searchform.instituteId" placeholder="请选择" filterable >
                            <el-option label="全部" key="" value=""></el-option>
                            <el-option v-for="item in instituteIdData" :key="item.orgId" :label="item.orgName" :value="item.orgId" >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发布状态：" prop="hIsPublic">
                        <el-select v-model="searchform.hIsPublic" placeholder="请选择" >
                            <el-option label="全部" value=""></el-option>
                            <el-option label="已发布" :value="1"></el-option>
                            <el-option label="未发布" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="fa fa-external-link" :disabled="pubBtnDisabled"
                    @click="pubclick" size="small" v-if="isHadFun('Public')">批量发布</el-button>
                    <el-button type="primary" icon="fa fa-external-link-square" 
                    @click="cancelpubclick" size="small" v-if="isHadFun('Public')" :disabled="cancelPubBtndisabled">批量取消发布</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="publictable" @selection-change="selectionchange"  @cell-click="cellclick"
                border 
                stripe 
                highlight-current-row 
                style="width: 100%"
                v-loading="loading" >
                    <el-table-column label="" width="30" fixed="left" type="expand">
                        <template slot-scope="props">
                            <el-form label-position="left" inline class="demo-table-expand">
                                <el-form-item label="职称要求：" v-if="props.row.postType==2">
                                    <span>{{ props.row.oTitleTypeName }}</span>
                                </el-form-item>
                                <el-form-item label="年龄要求：" v-if="props.row.postType==2">
                                    <span>{{ props.row.oAgeTypeName }}</span>
                                </el-form-item>
                                <el-form-item label="招聘形式：" v-if="props.row.postType==2" >
                                    <span>{{ props.row.oFromType }}</span>
                                </el-form-item>
                                <el-form-item label="招聘时间：" v-if="props.row.postType==2">
                                    <span>{{ props.row.oTimeDesc }}</span>
                                </el-form-item>
                                <el-form-item label="招聘范围：" v-if="props.row.postType==2">
                                    <span>{{ props.row.oRangeType }}</span>
                                </el-form-item>
                                <el-form-item label="生源要求：" v-if="props.row.postType==1">
                                    <span>{{props.row.gSourceType}}</span>
                                </el-form-item>
                                <el-form-item label="是否组织专业考试：" class="long" v-if="props.row.postType==1">
                                    <span>{{props.row.gIsProfessional==true?"是":"否"}}</span>
                                </el-form-item>
                                <el-form-item label="考察方式：" v-if="props.row.postType==1">
                                    <span>{{ props.row.gReviewType }}</span>
                                </el-form-item>
                                <el-form-item label="计划录用人数与笔试人选的确定比例：" class="long" v-if="props.row.postType==1">
                                    <span>{{ props.row.gWrittenProportion }}</span>
                                </el-form-item>
                                <el-form-item label="计划录用人数与面试人选的确定比例：" class="long" v-if="props.row.postType==1">
                                    <span>{{ props.row.gInterviewProportion }}</span>
                                </el-form-item>
                                <el-form-item label="招聘起始时间：" class="middle">
                                    <span>{{ props.row.expiryStartDate | moment("YYYY-MM-DD")}}</span>
                                </el-form-item>
                                <el-form-item label="招聘终止时间：" class="middle">
                                    <span>{{ props.row.expiryEndDate | moment("YYYY-MM-DD")}}</span>
                                </el-form-item>
                                <el-form-item label="其他条件：">
                                    <span>{{ props.row.other }}</span>
                                </el-form-item>
                                <el-form-item label="备注：">
                                    <span>{{ props.row.remark }}</span>
                                </el-form-item>
                                <el-form-item label="岗位简介：">
                                    <span>{{ props.row.postInfo }}</span>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="planName" label="计划" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="parentOrganName" label="单位" width="180" sortable fixed="left">
                    </el-table-column>
                    <el-table-column prop="orgName" label="部门" width="120" sortable fixed="left">
                    </el-table-column>
                    <el-table-column prop="postTitle" label="岗位名称" width="150" fixed="left" >
                    </el-table-column>
                    <el-table-column prop="needNum" label="人数" width="50">
                    </el-table-column>
                    <el-table-column prop="major" label="专业" width="220">
                    </el-table-column>
                    <el-table-column prop="eucationTypeName" label="学历要求" width="120" sortable>
                    </el-table-column>
                    <el-table-column prop="diplomaTypeName" label="学位要求" width="120" sortable>
                    </el-table-column>
                    <el-table-column prop="politicalType" label="政治面貌" width="100">
                    </el-table-column>
                    <el-table-column prop="gSourceType" label="生源要求" width="100">
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="170" sortable>
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="110">
                    </el-table-column>
                    <el-table-column prop="isPublic" label="发布情况" width="100" fixed="right">
                        <template slot-scope="scope">
                            {{scope.row.isPublic==true?"已发布":"未发布"}}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="110" align="center" fixed="right" >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark"  placement="right" v-if="scope.row.logDesc">
                                <div slot="content" >{{scope.row.logDesc}}</div>
                                <el-tag  type="danger" disable-transitions v-if="scope.row.status==10" >{{scope.row.statusName}}</el-tag>
                                <el-tag  type="info" disable-transitions v-if="scope.row.status==-10" >{{scope.row.statusName}}</el-tag>
                                <el-tag  type="primary" disable-transitions v-if="scope.row.status==0">{{scope.row.statusName}}</el-tag>
                                <el-tag  type="success" disable-transitions v-if="scope.row.status==20" >{{scope.row.statusName}}</el-tag>
                            </el-tooltip>
                            <div v-else>
                            <el-tag  type="danger" disable-transitions v-if="scope.row.status==10" >{{scope.row.statusName}}</el-tag>
                            <el-tag  type="info" disable-transitions v-if="scope.row.status==-10" >{{scope.row.statusName}}</el-tag>
                            <el-tag  type="primary" disable-transitions v-if="scope.row.status==0">{{scope.row.statusName}}</el-tag>
                            <el-tag  type="success" disable-transitions v-if="scope.row.status==20" >{{scope.row.statusName}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="RowPublic(scope.row)" type="text"  size="small" v-if="isHadFun('Public')&&!scope.row.isPublic">发布</el-button>
                            <el-button @click.stop="RowCancelPublic(scope.row)" type="text"  size="small" v-if="isHadFun('Public')&&scope.row.isPublic">取消发布</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
	</div>
</template>
<script>
    export default {
        name: 'post_public',
        data() {
            return {
                searchform: {
                    pageNum: 1,
                    pageSize: 10,
                    postName: "",
                    postMajor:"",
                    planEdu:"",
                    planDiploma:"",
                    birth:"",
                    postType:"",
                    planId:"",
                    hIsPublic:"",
                    instituteId:""
                },
                tableData: [],
                planIdData:[],
                postTypeData:[],
                instituteIdData:[],
                total: 0,
                loading: true,
                selectionRows:[],
                selectfield:"postTitle",
                keyword:"",
                pubBtnDisabled:true,
                cancelPubBtndisabled:true
            }
        },
        methods: {
            onSubmit() {
                this.searchform.postTitle="";
                this.searchform.postInfo="";
                this.searchform.major="";
                this.searchform[this.selectfield]=this.keyword;
                this.cancelPubBtndisabled=(this.searchform.hIsPublic===1)?false:true;
                this.pubBtnDisabled=(this.searchform.hIsPublic===0)?false:true;
                this.initData();
            },
            handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
            cellclick(row, column, cell, event){
                this.$refs.publictable.toggleRowSelection(row);
            },
            RowPublic(val){
                this.$confirm("确定要将 '"+val.postTitle+"' 发布到前台供报名么？","设置提示",{type:"warning"})
                .then(()=>{
                    var Vuethis=this;
                    var loading = Vuethis.$loading({
                        lock: true,
                        text: '发布中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$hrraxios.post(this.$api.plan.postPublic,{postId:val.postId})
                    .then((response)=>{
                        loading.close();
                        var redata=response.data;
                        if(redata.success==true){
                            Vuethis.$message({message:"发布成功！",type:"success"});
                            Vuethis.initData();
                        }else{
                            Vuethis.$message({message:redata.prompt,type:"error"});
                        }
                    })
                }).catch((error)=>{
                    loading.close();
                    console.log(error);
                });
            },
            RowCancelPublic(val){
                this.$confirm("确定要将 '"+val.postTitle+"' 取消发布么？取消岗位前台将不可见。","设置提示",{type:"warning"})
                .then(()=>{
                    var Vuethis=this;
                    var loading = Vuethis.$loading({
                        lock: true,
                        text: '取消中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$hrraxios.post(this.$api.plan.postCancelPublic,{postId:val.postId})
                    .then((response)=>{
                        loading.close();
                        var redata=response.data;
                        if(redata.success==true){
                            Vuethis.$message({message:"取消成功！",type:"success"});
                            Vuethis.initData();
                        }else{
                            Vuethis.$message({message:redata.prompt,type:"error"});
                        }
                    })
                }).catch((error)=>{
                    loading.close();
                    console.log(error);
                });
            },
            pubclick(){
                if(this.selectionRows.length==0)
                {
                    this.$message({message:"请先选择一行在操作",type:"warning"});
                    return;
                }
                this.$confirm("确定要批量发布这些岗位么？",{type:"warning"})
                .then(()=>{
                    var loading = this.$loading({
                        lock: true,
                        text: '发布中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis=this;
                    var PostfunArr=[];
                    this.selectionRows.forEach(myrow=>{;
                        var postRe=this.$hrraxios.post(this.$api.plan.postPublic,{postId:myrow.postId});
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                    .then(this.$axios.spread(function(){
                        loading.close();
                        var isalldel=true;
                        for(var i=0;i<arguments.length;i++){
                            if(arguments[i].data.success==false)
                            {
                                isalldel=false;
                            }
                        }
                        if(isalldel==true){
                            Vuethis.$message({message:"全部发布成功！",type:"success"});
                            Vuethis.initData();
                        }else{
                            //有删除失败的未处理
                        }
                    }));
                })
                .catch((error)=>{
                    
                });
            },
            cancelpubclick(){
                if(this.selectionRows.length==0)
                {
                    this.$message({message:"请先选择一行在操作",type:"warning"});
                    return;
                }
                this.$confirm("确定要批量取消发布这些岗位么？",{type:"warning"})
                .then(()=>{
                    var loading = this.$loading({
                        lock: true,
                        text: '取消中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis=this;
                    var PostfunArr=[];
                    this.selectionRows.forEach(myrow=>{;
                        var postRe=this.$hrraxios.post(this.$api.plan.postCancelPublic,{postId:myrow.postId});
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                    .then(this.$axios.spread(function(){
                        loading.close();
                        var isalldel=true;
                        for(var i=0;i<arguments.length;i++){
                            if(arguments[i].data.success==false)
                            {
                                isalldel=false;
                            }
                        }
                        if(isalldel==true){
                            Vuethis.$message({message:"全部取消成功！",type:"success"});
                            Vuethis.initData();
                        }else{
                            //有删除失败的未处理
                        }
                    }));
                })
                .catch((error)=>{
                    
                });
            },
			cellclick(row, column, cell, event){
				this.$refs.publictable.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
            initData() {
                var Vuethis = this;
                this.loading = true;
                this.$hrraxios.get(this.$api.plan.postPublicList, {
                        params: this.searchform
                    })
                    .then(function(response) {
                        Vuethis.loading = false;
                        var data = response.data;
                        if (data.success == true) {
                            Vuethis.tableData = data.data.list;
                            Vuethis.total = data.data.total;
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.loading = false;
                        console.log(error);
                    });
            },
            initParamsData(){
                this.$common.getplanlist(this,"planIdData");
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"post_Type"},"postTypeData",this);
                this.$common.getFunListByMCode(this,"PlanPostPublic");
                //所数据
                var Vthis=this;
                this.$hrraxios.get(Vthis.$api.plan.getinstituteList)
                .then((response)=>{
                    var data=response.data;
                    if(data.success==true){
                        Vthis.instituteIdData=data.data;
                    }else{
                        Vthis.$message.error("获取所数据初始化失败,请联系管理员");
                    }
                })
                .catch((error)=>{
                    console.log(error);
                })
            }
        },
        beforeRouteLeave(to, from, next) {
            // 导航离开该组件的对应路由时调用
            to.meta.row = from.meta.row;
            next();
        },
        created() {
            this.initData();
            this.initParamsData();
        }
    }
</script>
<style>
    #plan_post_public .el-button+.el-button{margin-left: 0;}
</style>
